package org.example.zone360.models

import kotlinx.serialization.Serializable
@Serializable
data class GetSinglePlayerResponse(
    val data: GetSinglePlayerData,
)
@Serializable
data class GetSinglePlayerData(
    val id: String = " ",
    val rev: String = " ",
    val coachName: String = " ",
    val email: String = " ",
    val firstName: String = " ",
    val lastName: String = " ",
    val nickName: String = " ",
    val latestAssessment: String = " ",
    val organization: String = " ",
    val imageUrl: String = " ",
    val nationality: String = "",
    val height: String = "",
    val ethnicity: String = "",
    val rating: Double = 0.0,
    val reviewCount : Int = 0,
    val team: String = "",
    val age: String = "",
    val weight: String = "",
    val number: String = "",
    val position: String = "",
    val userVideos: List<String> = emptyList(),
    val secondaryPosition: String = "",
    val foot: String = "",
    val payment: Payment = Payment(),
    val role: String = " ",
    val type: String = " ",
    val uid: String = " ",
    val botQuestionAsked : Int = 0,
    val teams: List<TeamsObject> = emptyList()
)